import { useEffect, useState } from 'react';
import { lerMeusInsights } from '../../paineis';
import type { InsightsDoBalconista } from '../../paineis';
import { CartaoInsight } from '../paineis/CartoesDeInsight';

/**
 * "COMO ESTOU INDO" — os insights do balconista no início dele: meta, premiação e projeção,
 * posição nas vendas, melhor dia e horário, produto campeão, sequência, recorde e pagamento.
 * Só os números DELA (a rota devolve só os da própria pessoa). Sem dado: o bloco não aparece.
 */
export function MeusInsights() {
  const [d, setD] = useState<InsightsDoBalconista | null>(null);
  useEffect(() => {
    let vivo = true;
    void lerMeusInsights().then((r) => vivo && r.ok && setD(r.dados));
    return () => {
      vivo = false;
    };
  }, []);
  if (!d || d.cartoes.length === 0) return null;
  return (
    <section className="bh-insights" aria-label="Como estou indo">
      <div className="bh-insights-cabeca">
        <h2>Como estou indo</h2>
        <span>
          semana de {d.semana.de.slice(8, 10)}/{d.semana.de.slice(5, 7)} a{' '}
          {d.semana.ate.slice(8, 10)}/{d.semana.ate.slice(5, 7)}
        </span>
      </div>
      <div className="in-grade bh-insights-grade">
        {d.cartoes.map((c) => (
          <CartaoInsight key={c.id} c={c} />
        ))}
      </div>
    </section>
  );
}
